import { createContext, memo, useState } from 'react';
import analytics from 'shared/utility/analytics';
import flow, { baseFlow, advancedFlow } from '../flow';
import {triggerScroll} from "shared/helpers";

const NavigationContext = createContext();

const NavigationProvider = memo(({ children }) => {
  const [selectedDetailType, setSelectedDetailType] = useState(null);
  
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [activeFlow, setActiveFlow] = useState(baseFlow);
  const [recalculatingFromIndex, setRecalculatingFromIndex] = useState(null);
  const [leadFormActive, setLeadFormActive] = useState(false);
  const [leadFormShowSucces, setLeadFormShowSucces] = useState(false);

  const toggleLeadForm = () => {
    setLeadFormActive(!leadFormActive)
  }

  const updateStepIndex = index => {
    const currentStepIsOnFinalPage = !!currentStep.output;
    const selectedIndexIsFinalPage = flow[index].output;
    if (currentStepIsOnFinalPage && index > currentStepIndex) {
      setActiveFlow(advancedFlow);
    } else {
      if (selectedIndexIsFinalPage && index < currentStepIndex) {
        setActiveFlow(baseFlow);
      }
    }
    analytics.send('Navigeer', flow[index].url);
    setCurrentStepIndex(index);
    triggerScroll();
  };

  const updateFlowIndex = index => {
    let i = (activeFlow === advancedFlow ? baseFlow.length : 0) + index
    analytics.send('Navigeer', flow[i].url);
    setSelectedDetailType(null);
    setCurrentStepIndex(i);
  }

  const currentStep = flow[currentStepIndex];
  const activeFlowStepIndex = activeFlow.findIndex(step => step.url === currentStep.url);
  const onResultPage = currentStep.output;
  const onFinalResultPage = currentStepIndex === flow.length - 1;

  return (
    <NavigationContext.Provider
      value={{
        currentStepIndex,
        selectedDetailType,
        setSelectedDetailType,
        flow,
        currentStep,
        activeFlow,
        activeFlowStepIndex,
        updateStepIndex,
        updateFlowIndex,
        leadFormActive,
        setLeadFormActive,
        toggleLeadForm,
        recalculatingFromIndex,
        setRecalculatingFromIndex,
        leadFormShowSucces,
        setLeadFormShowSucces,
        onResultPage,
        onFinalResultPage,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
});

export { NavigationContext, NavigationProvider };
